/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import { getMiddleWareBaseUrlFromAndroid } from '../components/userProfile/utils/webViewUtils';

const configFile = (env, instance = 'paytm') => {
  let sourceConfig = {};
  const envString = env || process.env.REACT_APP_ENV || 'development';
  if (envString === 'staging') {
    sourceConfig = process.env.REACT_APP_V2
      ? require(`./${envString}V2.js`)
      : require(`./${envString}.js`);
  } else if (envString === 'production') {
    sourceConfig = process.env.REACT_APP_V2
      ? require(`./${envString}V2.json`)
      : require(`./${envString}.json`);
  } else {
    sourceConfig = require(`./${envString}.json`);
  }

  return sourceConfig[process.env.INSTANCE || instance];
};

const envConfig = configFile(process.env.REACT_APP_ENV, process.env.INSTANCE);
const getLocation = (href) => {
  const l = document.createElement('a');
  l.href = href;
  return l;
};

let PATH_NAME = getLocation(envConfig.host).pathname;
const v2Path =
  process.env.REACT_APP_V2 && !PATH_NAME.includes('v2') ? 'v2/' : '';
PATH_NAME =
  PATH_NAME.length > 1 ? `${PATH_NAME}/${v2Path}` : `${PATH_NAME}${v2Path}`;
const baseUrl = getMiddleWareBaseUrlFromAndroid();

const config = {
  getOauthToken: `${envConfig.fsm.endpoint}/fse/fe/oauth`,
  mapType: `${envConfig.fsm.mapType}`,
  logout: `${envConfig.host}/logout`,
  permissions: `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/acl/permissions`,
  getAllResources: (queryString) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/referenceData/getAllResources?typeList=${queryString}`,
  /* Fetch All category for reporting tab */
  fetchBackwardStageChange: (leadId) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/fetchPossibleSubstages/${leadId}`,
  saveBackwardStage: `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/manualMovementOfLeadStage`,
  uploadFile: (url) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/${url}`,
  oauthURL: (theme) =>
    `${envConfig.oauth.endpoint}/oauth2/authorize?response_type=${envConfig.oauth.responseType}&client_id=${envConfig.oauth.clientId}&scope=${envConfig.oauth.scope}&redirect_uri=${envConfig.host}${envConfig.oauth.redirectURI}&theme=${theme}`,
  clientDetails: (custId) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/audit/${custId}`,
  fsmDetails: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/fetch/details?${queryString}`,
  permissionDetails: `${envConfig.fsm.endpoint}/fse/get/feature_toggles`,
  geohashLimitEnhancement: `${envConfig.fsm.endpoint}/fse/geohash/limit-increase`,
  getLiveLocation: (empCode) =>
    `${envConfig.fsm.endpoint}/fse/get/location?emp_id=${empCode}`,
  getZones: (qs) => `${envConfig.fsm.endpoint}/fse/get/zones${qs || ''}`,
  getZonesv2: (qs) => `${envConfig.fsm.endpoint}/fse/v2/get/zones${qs || ''}`,
  getZonesv3: (qs) => `${envConfig.fsm.endpoint}/fse/v3/get/zones${qs || ''}`,
  getZonesv4: (qs) => `${envConfig.fsm.endpoint}/fse/zones${qs || ''}`,
  getMerchantCount: (qs) =>
    `${envConfig.fsm.endpoint}/fse/zones/merchant-count${qs || ''}`,
  getCompetitorQrCount: (qs) =>
    `${envConfig.fsm.endpoint}/fse/priority-zones/competitor-count${qs || ''}`,
  createEdcLead: (leadId) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/fetchLeadDetails/${leadId}`,
  saveEdcDetails: `${envConfig.goldenGate.endpoint}/MerchantService/panel/v1/edc`,
  checkInGateMeeting: `${envConfig.fsm.endpoint}/gate-meeting/mark-attendance`,
  gateMeetingDetails: `${envConfig.fsm.endpoint}/gate-meeting/meeting_details`,
  gateMeetingCheckinStatus: `${envConfig.fsm.endpoint}/gate-meeting/attendance_detail`,
  startGateMeeting: `${envConfig.fsm.endpoint}/gate-meeting/start`,
  getUploadedImage: (dmsId) =>
    `${envConfig.fsm.endpoint}/dms/get/image?dmsId=${dmsId}`,
  uploadGateMeetingImage: `${envConfig.fsm.endpoint}/gate-meeting/admin/multipartImage`,
  endGateMeeting: `${envConfig.fsm.endpoint}/gate-meeting/end`,
  getPaymentStatus: (leadId) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/panel/v1/edc/payment?leadId=${leadId}`,
  edcLeadCreate: (entityType, solution, channel) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/panel/v1/solution/lead?entityType=${entityType}&solution=${solution}&channel=${channel}`,
  sendNotification: (leadId) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/panel/v1/notification/?leadId=${leadId}`,
  fetchDLDetails: (custId, dlNo, dob) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/validation/drivingLicense?userCustId=${custId}&dlNo=${dlNo}&dob=${dob}`,
  fetchVoterIdDetails: (voterId, custId) =>
    `${envConfig.goldenGate.endpoint}/MerchantService/oe/panel/v1/validation/voterId/${voterId}?userCustId=${custId}`,
  fetchPreviousTargets: (startDate, endDate) =>
    `${envConfig.fsm.endpoint}/fse/fetch/previous/targets?startDate=${startDate}&endDate=${endDate}`,
  fetchMerchants: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/v3/merchant/findMerchant?${queryString}`,
  fetchMerchantsV4: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/v4/merchant/findMerchant?${queryString}`,
  fetchZonesForAreaGreaterThanThreshold: `${envConfig.fsm.endpoint}/fse/get/zones/five-char`,
  fetchTeamZonesForAreaGreaterThanThreshold: `${envConfig.fsm.endpoint}/fse/get/team/zones/five-char`,
  fetchUrgentMerchants: `${envConfig.fsm.endpoint}/mhd/urgent_beats`,
  grabMerchants: `${envConfig.fsm.endpoint}/mhd/grab_request`,
  fetchCompetitorData: (id) =>
    `${envConfig.fsm.endpoint}/fse/qr_data?qrUpiCode=${id}`,
  getCheckinCheckout: (queryString) =>
    `${envConfig.fsm.endpoint}/attendance/check/status?${queryString}`,
  punchIn: (queryString) =>
    `${envConfig.fsm.endpoint}/attendance/punchIn?${queryString}`,
  punchOut: (queryString) =>
    `${envConfig.fsm.endpoint}/attendance/punchOut?${queryString}`,
  applyLeave: `${envConfig.fsm.endpoint}/attendance/applyLeave`,
  getMyAttendance: `${envConfig.fsm.endpoint}/attendance/myAttendance`,
  regularizeAttendance: `${envConfig.fsm.endpoint}/attendance/regularizeAttendance`,
  getLeaveData: `${envConfig.fsm.endpoint}/attendance/leaveManagement`,
  getLeaveRequest: `${envConfig.fsm.endpoint}/attendance/leaveManagementRequest`,
  getLeaveReason: `${envConfig.fsm.endpoint}/attendance/fetchReason`,
  getHolidayCal: (empCode) =>
    `${envConfig.fsm.endpoint}/attendance/holidayCalendar?empId=${empCode}`,
  approveAttendance: `${envConfig.fsm.endpoint}/attendance/approve`,
  getTags: (param) =>
    param
      ? `${envConfig.fsm.endpoint}/fse/get/tags?type=${param}`
      : `${envConfig.fsm.endpoint}/fse/get/tags?type=merchant`,
  getCalendarDetails: (startDate, endDate, empCode) =>
    `${
      envConfig.fsm.endpoint
    }/attendance/myCalendar?startDate=${startDate}&endDate=${endDate}${
      empCode ? `&empId=${empCode}` : ''
    }`,
  getCheckoutValidateDetails: `${envConfig.fsm.endpoint}/attendance/validateCheckout`,
  getMemberList: (empCode) =>
    `${envConfig.fsm.endpoint}/fse/listInfo?emp_id=${empCode}`,
  getFilters: (empId) =>
    `${envConfig.fsm.endpoint}/fse/fetch/filters?emp_id=${empId}&type=beatmapping`,
  getUserDetails: (empId) =>
    `${envConfig.fsm.endpoint}/fse/get/details?emp_id=${empId}`,
  merchantSearch: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/search/merchant?${queryString}`,
  pathTackingMerchants: (empId) =>
    `${envConfig.fsm.endpoint}/fse/trackingDetails?empId=${empId}`,
  getMapMyIndiaToken: 'https://outpost.mappls.com/api/security/oauth/token',
  getImmediateChild: `${envConfig.fsm.endpoint}/fse/get/hierarchy`,
  minVersionForGateMeetingAccuracy: '5.0.1',
  maxAcceptableAccuracy: 500,
  maxRetriesAllowed: 3,
  getDirectChild: (empId) =>
    `${envConfig.fsm.endpoint}/fse/get/hierarchy?empId=${empId}`,
  getGeocodeMMI: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/address/mapMyIndia?${queryString}`,
  umpPunchIn: `${envConfig.ump.endpoint}/api/v1/attendance/punchin`,
  umpPunchOut: `${envConfig.ump.endpoint}/api/v1/attendance/punchout`,
  dmsImageUpload: `${envConfig.cbrDs.endpoint}/dm/document/v1/uploadDocument`,
  getZoneInfo: (zoneId) =>
    `${envConfig.fsm.endpoint}/fse/getZoneInfo?zoneId=${zoneId}`,
  assignOrUnassignZones: (qs) =>
    `${envConfig.fsm.endpoint}/fse/assignOrUnassignZones${qs || ''} `,
  getEarningAndSettlementSummary: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/getEarningAndSettlementSummary?${queryString}`,
  settlementSummary: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/getSettlementDetails?${queryString}`,
  mapMyIndiaEndpoint: `${envConfig.fsm.mmiEndpoint}/${envConfig.fsm.mapMyIndiaKey}/map_load?v=1.5&plugin=cluster`,
  reverseGeocode: (lat, long) =>
    `${envConfig.fsm.mmiEndpoint}/${envConfig.fsm.mapMyIndiaKey}/rev_geocode?lng=${long}&lat=${lat}`,
  geohashSearch: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/searchZone?geoHash=${queryString}`,
  geohashTeamSearch: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/team/searchZone?geoHash=${queryString}`,
  addPanCard: (custId, name) =>
    `${baseUrl}v2/validation/pancard/${custId}?name=${name}&solutionType=psa`,
  updateProfile: (queryString) =>
    `${baseUrl}v1/agent/update/profile?${queryString}`,
  getPincode: () =>
    `${envConfig.uad.endpoint}/uad/v1/addressInformation/oauth/pincode`,
  getAuthLetter: (empId) =>
    `${envConfig.fsm.endpoint}/fse/auth/letter?empId=${empId}`,
  getUnassign: (qs) =>
    `${envConfig.fsm.endpoint}/fse/fetchUnassigned${qs || ''}`,
  fseImageUpload: (dmsId, empCode) =>
    `${envConfig.fsm.endpoint}/fse/upload/image?dmsId=${dmsId}&empId=${empCode}`,
  fetchMerchantData: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/find/merchantData?${queryString}`,
  fetchMerchantDatav2: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/v2/find/merchantData?${queryString}`,
  getTeamSubTeamMapping: `${envConfig.fsm.endpoint}/fse/team/subteam/mapping`,
  getDepartmentNames: `${envConfig.fsm.endpoint}/fse/department/names`,
  saveBeatMapping: `${envConfig.fsm.endpoint}/fse/v2/save/beatmapping`,
  closeUrgentBeat: `${envConfig.fsm.endpoint}/mhd/close_mhd_beat `,
  createBeatMapping: `${envConfig.fsm.endpoint}/mhd/save_mhd_info?requestType=mhd`,
  deactivateBeat: (beatMappingId) =>
    `${envConfig.fsm.endpoint}/mhd/deactivate_beat?beatMappingId=${beatMappingId}`,
  downloadUrgentBeat: ({ startDate, endDate }) =>
    `${envConfig.fsm.endpoint}/mhd/download_urgent_beats?startDate=${startDate}&endDate=${endDate}`,
  fetchBeatMapping: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/fetch/beat/details?${queryString}`,
  fetchUrgentBeatMapping: `${envConfig.fsm.endpoint}/mhd/dashboard/urgent_beats`,
  fetchPincodeDetails: (pincode) =>
    `${envConfig.fsm.endpoint}/mhd/pincode_details?pincode=${pincode}`,
  getAddressDetails: (lat, long) =>
    `${envConfig.fsm.endpoint}/fse/address/reverse/geoCoding?lat=${lat}&lon=${long}`,
  getFseList: (queryString = '') =>
    `${envConfig.fsm.endpoint}/fse/list${queryString}`,
  getFseInfo: (query) => `${envConfig.fsm.endpoint}/fse/details/oe?${query}`,
  getFseIcardInfo: `${envConfig.fsm.endpoint}/fse/admin/fetch/details/cif`,
  getFseInfoCsv: (query) =>
    `${envConfig.fsm.endpoint}/fse/details/oe/csv?${query}`,
  getFseExitHierarchy: (query) =>
    `${envConfig.fsm.endpoint}/fse-exit/hierarchy?type=${query}`,
  getAllTeams: `${envConfig.fsm.endpoint}/fse/team`,
  getMerchantMetaData: `${envConfig.fsm.endpoint}/fse/merchant/meta/data`,
  getBeatMetaData: `${envConfig.fsm.endpoint}/mhd/mhd_meta_details`,
  getPriorityZonesV2: `${envConfig.fsm.endpoint}/fse/priority-zones`,
  billingAPImmi: (qs) =>
    `${envConfig.fsm.endpoint}/fse/address/map_my_india/billing_entry${
      qs || ''
    }`,
  getZoneListView: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/get/zone/list?${queryString}`,
  getZoneListViewV2: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/v2/get/zone/list?${queryString}`,
  updateMaxZones: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/update/maxZones?${queryString}`,
  internalAdmin: `${envConfig.fsm.endpoint}/fse/admin/internal`,
  assignUrgentBeatToFse: `${envConfig.fsm.endpoint}/mhd/assign`,
  getWeeklyView: `${envConfig.fsm.endpoint}/payout/earningsDetail`,
  getDates: `${envConfig.fsm.endpoint}/payout/cycles`,
  getFairdayEarning: (queryString) =>
    `${envConfig.fsm.endpoint}/payout/getFSEEarnings${queryString}`,
  incentiveCriteria: `${envConfig.goldenGate.appEndpoint}embed?url=https://drive.google.com/file/d/1j8PiQHIGuvrJPYhaU7WuW0riVLdK_5df/view?usp=sharing`,
  getFileInfo: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/admin/file/sample?type=${queryString}`,
  getFileTypes: () => `${envConfig.fsm.endpoint}/fse/admin/file/type`,
  getFileProcess: `${envConfig.tms.endpoint}/v2/fileProcess/fetchProcess`,
  getSearchCount: (queryString) =>
    `${envConfig.tms.endpoint}/v2/fileProcess/searchCount?process=${queryString}`,
  getUploadedFileInfo: () => `${envConfig.fsm.endpoint}/fse/admin/file`,
  getUploadedFileInfoTMS: (pageNumber, numberOfRecords, processName) =>
    `${envConfig.tms.endpoint}/v2/fileProcess/fetchStatus?pageNo=${pageNumber}&noOfRecords=${numberOfRecords}&process=${processName}`,
  cifUploadFile: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/admin/file${queryString}`,
  cifUploadFileTMS: () => `${envConfig.tms.endpoint}/v2/fileProcess/upload`,
  cifFileDownload: (queryString) =>
    `${envConfig.fsm.endpoint}/fse/admin/file/download?filename=${queryString}`,
  cifFileDownloadTMS: (queryString) =>
    `${envConfig.tms.endpoint}/v2/fileProcess/download?outputFile=${queryString}`,
  getDmsImage: (dmsId) =>
    `${envConfig.fsm.endpoint}/dms/admin/get/image?dmsId=${dmsId}`,
  downloadCIFSampleFile: (queryString) =>
    `${envConfig.fsm.endpoint}${queryString}`,
  downloadCIFSampleFileTMS: (queryString) =>
    `${envConfig.tms.endpoint}/v2/fileProcess/sample?process=${queryString}`,
  getAllDesignations: `${envConfig.fsm.endpoint}/admin/designation`,
  getAllRoles: `${envConfig.fsm.endpoint}/fse/admin/role`,
  getRoleDesignationMapping: `${envConfig.fsm.endpoint}/fse/admin/role-designation`,
  saveRoleDesignationMapping: `${envConfig.fsm.endpoint}/fse/admin/role-designation`,
  getServiceFlowFilters: () =>
    `${envConfig.fsm.endpoint}/service-flow/v3/filters`,
  applyServiceFlowFilters: () =>
    `${envConfig.fsm.endpoint}/service-flow/v3/service-beats`,
  ggAppPdfDeeplink: `${envConfig.goldenGate.appEndpoint}embed?url=`,
  getMerchantDetailsList: `${envConfig.fsm.endpoint}/service-flow/service-beats-details`,
  getWorkingHours: `${envConfig.fsm.endpoint}/service-flow/working-hours`,
  fetchBeats: `${envConfig.fsm.endpoint}/service-flow/v3/service-beats`,
  fetchServiceBeatTotalCount: `${envConfig.fsm.endpoint}/service-flow/service-beats/total-count`,
  getTLReportees: `${envConfig.fsm.endpoint}/service-flow/reportees`,
  getASMReportees: `${envConfig.fsm.endpoint}/service-flow/reportees/tl`,
  getASMViewDetails: `${envConfig.fsm.endpoint}/service-flow/pendency`,
  assignTL: `${envConfig.fsm.endpoint}/service-flow/delegate/assign`,
  unAssignTL: `${envConfig.fsm.endpoint}/service-flow/delegate/unassign`,
  assignReassignAgent: `${envConfig.fsm.endpoint}/service-flow/assign-reassign`,
  acceptReject: `${envConfig.fsm.endpoint}/service-flow/accept-reject`,
  assignToMe: `${envConfig.fsm.endpoint}/service-flow/tl/self-assign`,
  getServiceFlowTags: `${envConfig.fsm.endpoint}/fse/tags`,
  assignBeat: `${envConfig.fsm.endpoint}/service-flow/assign-beat`,
  unAssignBeat: `${envConfig.fsm.endpoint}/service-flow/unassign-beat`,
  getFacingIssueList: `${envConfig.fsm.endpoint}/service-flow/issues`,
  submitFacingIssue: `${envConfig.fsm.endpoint}/service-flow/facing-issue`,
  getRescheduleReason: `${envConfig.fsm.endpoint}/service-flow/reschedule-reasons`,
  postRescheduleRequest: `${envConfig.fsm.endpoint}/service-flow/reschedule-beat`,
  deactivateBeatRequest: `${envConfig.fsm.endpoint}/fse/admin/file/deactivate`,
  fetchFiveCharZones: `${envConfig.fsm.endpoint}/fse/get/zones/five-char`,
  fetchPriorityFiveCharZones: `${envConfig.fsm.endpoint}/fse/get/priority-zones/five-char`,
  fetchSixCharZones: `${envConfig.fsm.endpoint}/fse/get/zones/six-char`,
  fetchPrioritySixCharZones: `${envConfig.fsm.endpoint}/fse/get/priority-zones/six-char`,
  fetchSixCharTeamZones: `${envConfig.fsm.endpoint}/fse/get/team/zones/six-char`,

  getAdminTeamSequence: (team) =>
    `${envConfig.fsm.endpoint}/fse/admin/team-sequence?teamName=${team}`,
  getMerchantMobile: (pgMid) =>
    `${
      envConfig.fsm.endpoint
    }/fse/boss/merchantMobile?pgMid=${encodeURIComponent(pgMid)}`,
  updateAdminTeamSequence: `${envConfig.fsm.endpoint}/fse/admin/team-sequence/update`,
  getTeamSequence: (team, subTeam) =>
    `${envConfig.fsm.endpoint}/fse/team-sequence?teamName=${encodeURIComponent(
      team,
    )}${subTeam ? `&subTeamName=${encodeURIComponent(subTeam)}` : ''}`,
  getSearchCategories: `${envConfig.fsm.endpoint}/service-flow/feature-toggle/configured-values`,
  searchServiceFlowMerchants: `${envConfig.fsm.endpoint}/service-flow/service-search-merchant`,
  searchServiceFlowMerchantsV2: `${envConfig.fsm.endpoint}/service-flow/v3/service-search-merchant`,

  getTeamSubTeamWhiteListMapping: `${envConfig.fsm.endpoint}/fse/admin/team/subteam/mapping`,
  getDepartmentWhiteListMapping: `${envConfig.fsm.endpoint}/fse/admin/department/names`,
  saveDepartmentWhiteListMapping: `${envConfig.fsm.endpoint}/fse/department`,
  saveTeamSubTeamWhiteListMapping: `${envConfig.fsm.endpoint}/fse/admin/team-subteam`,

  getVisitingCardDetails: `${envConfig.fsm.endpoint}/fse/visiting-card`,
  imgUploadUrl: `${envConfig.fsm.endpoint}/fse/admin/upload/image`,
  getAddTaskList: (team, subTeam) =>
    `${envConfig.fsm.endpoint}/service-flow/tags-for-team?team=${team}&subteam=${subTeam}`,
  updateTaskList: `${envConfig.fsm.endpoint}/service-flow/task`,
  sendBeatToMHD: `${envConfig.fsm.endpoint}/service-flow/merchant-uncontactable`,
  updateMerchantAddress: `${envConfig.fsm.endpoint}/service-flow/merchant/address`,
  getReporteesRequestCount: `${envConfig.fsm.endpoint}/service-flow/reportees/requests-count`,
  checkIsOtpRequired: `${envConfig.fsm.endpoint}/service-flow/isOtpRequired`,
  generateOtp: `${envConfig.fsm.endpoint}/service-flow/generate-otp`,
  validateOtp: `${envConfig.fsm.endpoint}/service-flow/validate-otp`,
  skipOtp: (pgmid, dsn) =>
    `${envConfig.fsm.endpoint}/service-flow/skip-otp?pgmid=${pgmid}&dsn=${dsn}`,
  getRejectReason: `${envConfig.fsm.endpoint}/service-flow/reject-reasons`,
  getNetworkBatteryStatus: (deviceId, pgMid) =>
    `${envConfig.fsm.endpoint}/service-flow/device-battery-details?deviceId=${deviceId}&pgMid=${pgMid}`,
  getTeamSubTeamMappingVMNPanel: `${envConfig.fsm.endpoint}/fse/admin/team/subteam/mapping`,
  getFsmAdminPermissions: `${envConfig.oe.endpoint}/api/oe/panel/v1/acl/permissions`,
  getAdminTeamSubTeamSequence: (team, subTeam) =>
    `${
      envConfig.fsm.endpoint
    }/fse/admin/team-sequence?teamName=${encodeURIComponent(team)}${
      subTeam ? `&subTeamName=${encodeURIComponent(subTeam)}` : ''
    }`,
  getGoogleMapNavigationUrl: (source, destination) =>
    `http://maps.google.com/maps?saddr=${source}&daddr=${destination}`,
  mapQrCodeDeepLink: 'paytmgg://goldengate-app/mapQrCode?isFSM=true',
  soundBoxDeepLink: 'paytmgg://goldengate-app/soundbox?isFSM=true',
  qrMerchantDeepLink: 'paytmgg://goldengate-app/qr_merchant?isFSM=true',
  merchant_100_kDeepLink: 'paytmgg://goldengate-app/merchant_100_k?isFSM=true',
  revisitDeepLink: 'paytmgg://goldengate-app/revisit?isFSM=true',
  bankUpdate:
    'paytmgg://goldengate-app/h5page?url=newui/psa/bankUpdate/homepage',
  cstFlowDeepLink: 'paytmgg://cst_flow',
  telephony: `${envConfig.fsm.endpoint}/telephony/v2/call`,
  checkSendbird: (pdMid = '') =>
    `${envConfig.fsm.endpoint}/sendbird/check?pgMid=${pdMid}`,
  submitSynchronizedEmpId: (empId) =>
    `${envConfig.fsm.endpoint}/fse/oauth-custId?empId=${empId}`,
  fetchAgentPermission: `${envConfig.fsm.endpoint}/fse/agent-permission`,
  deactivateTmsBeat: (fileName) =>
    `${envConfig.tms.endpoint}/v2/fileProcess/deactivate?s3FileName=${fileName}`,
  url: {
    home: `${PATH_NAME}`,
    login: `${PATH_NAME}login`,
    base: `${PATH_NAME}base`,
    indexHTML: `${PATH_NAME}index.html`,
    fsm: `${PATH_NAME}fsm`,
    userProfile: `${PATH_NAME}userProfile`,
    targetView: `${PATH_NAME}fsm/targetView`,
    fseView: `${PATH_NAME}fsm/fseView`,
    subTargetView: `${PATH_NAME}fsm/subTargetView`,
    teamTracking: `${PATH_NAME}fsm/teamTracking`,
    selfTracking: `${PATH_NAME}fsm/selfTracking`,
    subTeamTracking: `${PATH_NAME}fsm/subTeamTracking`,
    zoneTracking: `${PATH_NAME}fsm/zoneTracking`,
    target: `${PATH_NAME}fsm/target`,
    targetCard: `${PATH_NAME}fsm/targetCard`,
    filterPanel: `${PATH_NAME}fsm/filterPanel`,
    searchPanel: `${PATH_NAME}fsm/searchPanel`,
    merchantMap: `${PATH_NAME}fsm/merchantMap`,
    listing: `${PATH_NAME}fsm/merchantMap/info`,
    editAddress: `${PATH_NAME}fsm/merchantMap/info/editAddress`,
    addTask: `${PATH_NAME}fsm/serviceflow/addTask`,
    attendance: `${PATH_NAME}fsm/attendance`,
    holidayCalendar: `${PATH_NAME}fsm/attendance/holidayCalendar`,
    leaveManagement: `${PATH_NAME}fsm/attendance/leaveManagement`,
    request: `${PATH_NAME}fsm/request`,
    calendar: `${PATH_NAME}fsm/calendar`,
    calendarUser: `${PATH_NAME}fsm/calendar/user`,
    attendanceRecords: `${PATH_NAME}fsm/attendanceRecords`,
    errorFallback: `${PATH_NAME}errorFallback`,
    profile: `${PATH_NAME}fsm/profile`,
    searchedTracking: `${PATH_NAME}fsm/searchedTracking`,
    pathTracking: `${PATH_NAME}fsm/pathTracking`,
    merchantMapSearch: `${PATH_NAME}fsm/merchantMapSearch`,
    merchantMapViewZone: `${PATH_NAME}fsm/merchantMapViewZone`,
    userCalendar: `${PATH_NAME}fsm/calendar/userCalendar`,
    myZone: `${PATH_NAME}fsm/myZone`,
    geoHashSearch: `${PATH_NAME}fsm/geoHashSearch`,
    vmnMerchantDetail: `${PATH_NAME}fsm/vmnMerchantDetail`,
    edcPanel: `${PATH_NAME}fsm/edcPanel`,
    editTask: `${PATH_NAME}fsm/merchantMap/editTask`,
    assignFse: `${PATH_NAME}fsm/merchantMap/assignFse`,
    plotMerchant: `${PATH_NAME}fsm/plotMerchant`,
    fairDay: `${PATH_NAME}fairday`,
    myEarnings: `${PATH_NAME}fairday/myEarnings`,
    CIF: `${PATH_NAME}cif`,
    CIF_VMN_DETAILS: `${PATH_NAME}cif/vmnDetails`,
    WHITELISTING: `${PATH_NAME}cif/whiteListing`,
    FSE_UPLOAD: `${PATH_NAME}cif/fseUpload`,
    TASK_UPLOAD: `${PATH_NAME}cif/taskUpload`,
    FSE_INFO: `${PATH_NAME}cif/fseInfo`,
    FSE_LIST: `${PATH_NAME}cif/fseList`,
    MHD: `${PATH_NAME}cif/merchantHelpdesk`,
    ROLE_DESIGNATION_MAPPING: `${PATH_NAME}cif/roleDesignationMapping`,
    FSE_ICARD: `${PATH_NAME}cif/fseIcard`,
    SERVICE_FLOW: `${PATH_NAME}fsm/serviceFlow`,
    serviceFlowList: `${PATH_NAME}fsm/service/list`,
    assignReassignRequest: `${PATH_NAME}fsm/serviceflow/assignrequest`,
    assignToTL: `${PATH_NAME}fsm/serviceflow/assign-to-tl`,
    searchAgent: `${PATH_NAME}fsm/serviceflow/assignrequest/searchagent`,
    facingIssue: `${PATH_NAME}fsm/serviceFlow/facingIssue`,
    rescheduleRequest: `${PATH_NAME}fsm/serviceflow/reschedule`,
    landingPage: `${PATH_NAME}fsm/landingPage`,
    generateOtpPage: `${PATH_NAME}fsm/generateOtp`,
    exitManagementPage: `${PATH_NAME}fsm/exitManagement`,
    pendingDues: (query) =>
      `${envConfig.fsm.endpoint}/fse-exit/pending-dues${
        query ? `?childEmpId=${query}` : ''
      }`,
    initiateResignationPage: `${PATH_NAME}fsm/initiateResignation`,
    getFseExitInfo: `${envConfig.fsm.endpoint}/fse-exit/details`,
    fseResign: `${envConfig.fsm.endpoint}/fse-exit/resign`,
    getFseExitInfoFromNotifications: (query) =>
      `${envConfig.fsm.endpoint}/fse-exit/details${
        query ? `?empId=${query}` : ''
      }`,
    getSeparationReasons: `${envConfig.fsm.endpoint}/fse-exit/separation-reasons`,
    UTILITY: `${PATH_NAME}cif/utility`,
    getSearchResult: `${envConfig.fsm.endpoint}/fse/search-reportees`,
  },
};
export default config;
